import React, { useContext, useEffect, useState } from 'react';
import { Card, Divider, Icon, Radio, Button } from 'antd';
import { GlobalStateContext } from '../context/GlobalStateProvider';
import { TooltipHint } from '../components/metadata/TooltipHint';
import { navigate, navigateWithData } from '../navigation/navigationHistory';
import {convertToQuote} from '../api/applicationAPI';
import {navigateToStep} from '../components/Workflow';
import {ConsumerConsentData} from './data/ConsumerConsentData';
import {GA_CONFIGURATION, sendGoogleAnalyticsEvent} from "../utils/googleAnalyticsUtils";

function handleError(err) {
  const statusCode = (err.response ? err.response.status : 0);
    
  if ((statusCode === 503) || (err.message === "Network Error")) {
    navigate('/server-maintenance');
  }
  throw err;
}

const { Meta } = Card;
const actionTranslations = {
  convertToQuote: (systemId, typeCd, navigateStep, scrollCoordinates) => {
    convertToQuote(systemId, typeCd).then(() => {
      navigate(`/application/${systemId}`);
      navigateToStep(navigateStep);
      scrollTo(...scrollCoordinates);
    }).catch(err => handleError(err));
  }
};

function performAction(configuration) {
  if(configuration.execute && actionTranslations[configuration.execute]) {
    actionTranslations[configuration.execute](...configuration.arguments)
  }
}

export function ConsumerConsent({
  consentMessage,
  route,
  convertToQuoteAction,
  config,
  ...props
}) {
  const data = history.state.data;
  let consentForm = config.find(v=>v.productVersionId === data.model.basicPolicy.productVersionIdRef)
  consentForm = consentForm ? consentForm : config[0];
  let { acceptRadioButtonText,
    declineRadioButtonText,
    acceptHintText,
    declineHintText,
    submitConsentButtonText,
    declineConsentButtonText} = consentForm;
  const globalState = useContext(GlobalStateContext);
  const { isDesktop, isMobile, isTablet, changePaymentLayout } = globalState;
  const [componentMeta, setComponentMeta] = useState({
    value: null,
  });

  if (acceptRadioButtonText && declineRadioButtonText) {
    declineConsentButtonText = null;
  }

  useEffect(() => {
    if (declineConsentButtonText && declineConsentButtonText.length && !componentMeta.value) {
      setComponentMeta({
        value: 'Yes',
      });
    }
  });


  const getCardWidth = () => {
    if (isDesktop) {
      return '70%';
    }
    if (isTablet && !changePaymentLayout) {
      return '90%';
    }
    if (changePaymentLayout) {
      return '100%';
    }
  };

  const styles = {
    cardContainer: {
      width: getCardWidth(),
      margin: changePaymentLayout ? '' : 'auto',
      paddingTop: '32px',
      paddingBottom: '32px'
    },
    divider: {
      marginTop: '16px',
      marginBottom: '16px',
    },
    dividerContainer: {
      margin: 'auto',
      width: isTablet ? '85%' : '65%',
    },
    sectionContainer: {
      width: isTablet ? '75%' : '50%',
      display: 'flex',
      alignItems: 'center',
    },
    consumerConsentDataContainer:{
      display: 'flex',
      marginLeft: '38px',
      marginTop: '2em',
      flexDirection: 'column',
    },
    radioStyle:{
      display: 'block',
      height: '30px',
      lineHeight: '30px',
      marginLeft: '38px',
      marginRight: '0px',
    },
  };

  const onChange = (e) => {
    setComponentMeta({
      value: e.target.value,
    });
  };

  const submitDeclineButton = () => {
    const applicationNumber = data ? data.model.applicationNumber : '';
    sendGoogleAnalyticsEvent(GA_CONFIGURATION.Decline_Consumer_Consent, true);
    navigateWithData('/decline-consumer-consent', applicationNumber);
  };

  const submitConsentButton = () => {
    const applicationNumber = data ? data.model.applicationNumber : '';
    if (componentMeta.value === 'Yes') {
      sendGoogleAnalyticsEvent(GA_CONFIGURATION.Accept_Consumer_Consent, true);
      if(data.actionData) {
        performAction(data.actionData)
      }
    } else {
      sendGoogleAnalyticsEvent(GA_CONFIGURATION.Decline_Consumer_Consent, true);
      navigateWithData('/decline-consumer-consent', applicationNumber);
    }
  };

  return (
    <div className='gray-background'>
      <Card style={styles.cardContainer}>
        <Meta
          avatar={
            <Icon
              type='info-circle'
              style={{ color: '#f5222d', fontSize: '24px' }}
            />
          }
          title='Consumer Consent'
          className='consumer-consent-title'
        />
        <Divider style={styles.dividerContainer} />
        <div
          style={styles.consumerConsentDataContainer}
        >
          <ConsumerConsentData/>
        </div>
        {acceptRadioButtonText && declineRadioButtonText ? (
            <Radio.Group buttonStyle='solid' style={{ marginTop: '0.5em' }}>
              <div style={styles.sectionContainer}>
                <Radio style={styles.radioStyle} value='Yes' onChange={onChange}>
                  {acceptRadioButtonText}
                </Radio>
                <TooltipHint
                    style={{ marginLeft: '0.5em' }}
                    hintText={acceptHintText}
                />
              </div>
              <div style={styles.sectionContainer}>
                <Radio style={styles.radioStyle} value='No' onChange={onChange}>
                  {declineRadioButtonText}
                </Radio>
                <TooltipHint
                    style={{ marginLeft: '0.5em' }}
                    hintText={declineHintText}
                />
              </div>
            </Radio.Group>
        ) : (
            ''
        )}
        <div className='btn-group'>
          {declineConsentButtonText ? (
            <Button
                type='secondary'
                onClick={submitDeclineButton}
                style={{ marginRight: '4px' }}
            >
              {declineConsentButtonText}
            </Button>
          ) : (
            ''
          )}
          <Button
            type='primary'
            onClick={submitConsentButton}
            disabled={!componentMeta.value}
          >
            {submitConsentButtonText}
          </Button>
        </div>
      </Card>
    </div>
  );
}

